import { render, staticRenderFns } from "./PromotionalDeliveryLogForm.vue?vue&type=template&id=bc2b3f98"
import script from "./PromotionalDeliveryLogForm.vue?vue&type=script&lang=js"
export * from "./PromotionalDeliveryLogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports